<div class="position-reletivediv popup-inner-space">
    <div class="betweenheader"></div>

    <div class="text-right flow-right">
        <img src="assets/images/close.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()">
    </div>

    <form class="width100 " [formGroup]="exportoptionform">
        <div class="container-data56 popup-inner-space mt-3">
            <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
        </div>
        <div class="row report_btn">
            <div class="col-lg-12 d-flex cursor-pointer padding-right-0">
                <div style="margin: auto 0;">
                    <input id="Export to PDF" type="radio" value="PDF" name="ExportType" formControlName="ExportType"
                        (change)="onChange('PDF')">
                    <label class="ml-1">Export to PDF</label>
                </div>
                <div class="ml-2" style="margin: auto 0;">
                    <input id="Export to Excel" type="radio" value="Excel" name="ExportType"
                        formControlName="ExportType" (change)="onChange('EXCEL')">
                    <label class="ml-1">Export to Excel</label>
                </div>
                <div class="col-lg-5 mt-1 padding-left-5 text-right">
                    <button class="btncommon" id="btnNewdashboardAdd" (click)="Export()">Export</button>
                </div>
            </div>
        </div>
    </form>
</div>